// Typelizer digest d1dd9204bf8ee30027c46aa9d1899c77
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /email_verifications/:token */
  show: (
    params: { token: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/email_verifications/:token', params, options),
    method: 'get',
  }),
}
